import path from 'path-browserify';

import type { UploaderState } from '../state';

const getUploadAssetTitle = (state: UploaderState): string => {
  const { customAssetTitle, customFileName } = state.options;
  if (customAssetTitle) {
    return customAssetTitle;
  }

  if (customFileName) {
    return customFileName;
  }

  const parsedPath = path.parse(state.fileInfo.targetPath);
  return parsedPath.base;
};

export default getUploadAssetTitle;
